import React, { forwardRef, memo, ReactNode } from 'react'

export interface TreeLayoutProps {
    children?: ReactNode
    className?: string
}

/**
 * Layout wrapper for <TreeView /> component,
 * also provides a ref to the container for dynamic sizing
 * @param {TreeLayoutProps} TreeLayoutProps - Component props
 * @returns {ReactElement} Rendered TreeLayout component
 */
export const TreeLayout = memo(
    forwardRef<HTMLDivElement, TreeLayoutProps>(
        ({ children, className }, ref) => {
            return (
                <div
                    data-testid="tree-layout"
                    ref={ref}
                    className={className}
                    id="tree-layout-id"
                >
                    {children}
                </div>
            )
        }
    )
)
